import { render, staticRenderFns } from "./ConfirmArea.vue?vue&type=template&id=db7af4ba&scoped=true"
import script from "./ConfirmArea.vue?vue&type=script&lang=js"
export * from "./ConfirmArea.vue?vue&type=script&lang=js"
import style0 from "./ConfirmArea.vue?vue&type=style&index=0&id=db7af4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7af4ba",
  null
  
)

export default component.exports